export const ALBUM_DATES = {
  1: "07-2023",
  2: "06-2023",
  3: "12-2023",
};
